import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getActiveRideWithIsVendorRide = async (requestId: string, attachIsVendorRide: boolean) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      requestId,
      attachIsVendorRide,
    },
    query: graphql(`
      query GetActiveRideWithIsVendorRide($requestId: String!, $attachIsVendorRide: Boolean!) {
        getActiveRideWithIsVendorRide(requestId: $requestId, attachIsVendorRide: $attachIsVendorRide) {
          requestId
          status
          orderedBy
          isVendorRide
          curLat
          curLng
          startLocation
          startLat
          startLong
          destination
          destinationLat
          destinationLng
          endLocation
          endLat
          endLong
        }
      }
    `),
  });

  return response.data.getActiveRideWithIsVendorRide;
};
